import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import GrammatechCodeSentryConfigListing from './GrammatechCodeSentryConfigListing'
import GrammatechCodeSentryCredentialForm from './GrammatechCodeSentryCredentialForm'

export default function GrammatechCodeSentryPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={GrammatechCodeSentryCredentialForm}
            PullConfigListingView={GrammatechCodeSentryConfigListing}
        />
    )
}
